import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { STORES_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ImageDTO, RequestDTO, ResponseDTO } from "interface";

type storeType = {
  id: number;
  cityId: number;
  city: string;
  name: string;
  isActive: boolean;
  mainSellerUserId: number;
  mainSellerUserName: string;
  logo: ImageDTO;
  isRecommended: boolean;
  link?: string;
  lastVisit?: string;
  registerDatePersian?: string;
  rate: number;
  sellCount: number;
  orderCount: number;
  productCount: number;
};
type storesRequestType = RequestDTO<string>;
type useGetStoresOptions = UseQueryOptions<
  ResponseDTO<storeType[]>,
  unknown,
  ResponseDTO<storeType[]>
>;

const getStores = async (
  requestData: storesRequestType
): Promise<ResponseDTO<storeType[]>> => {
  const res = await instance.post(STORES_END_POINTS.list, requestData);

  return res.data;
};

export const useGetStores = (
  params: storesRequestType,
  config?: useGetStoresOptions
) => {
  return useQuery({
    queryKey: [
      STORES_END_POINTS.list,
      params.page,
      params.pageSize,
      ...(params.inputParams.filters ? params.inputParams.filters : []),
    ],
    queryFn: () => getStores(params),
    ...config,
  });
};
